  import React from 'react';
  import BaseComponent from '../../baseClasses/BaseComponent'; 
  import PopupMenu from '../../components/PopupMenu';
  import LoadingDots from '../../components/LoadingDots';
  import caret from '../../assets/images/caret.svg';
  import './ComboBox.scss';
  import Input from '../Input';

  // Change ComboBox to the appropriate name
  export default class ComboBox extends BaseComponent {

    constructor(props) {
      super(props);
      this.state = {
        selected: false,
        options: props.options,
      };
      this.state.initialValue = this.props.currentOption ? this.props.currentOption.name : '';
    }

    setFocus() {
      if (this.comboBox) {
        this.comboBox.setAttribute('tabIndex', Math.ceil(Math.random() * 100));
        this.comboBox.focus();
      }
    }

    componentDidMount() {
      if (this.props.noFocus) {
        return;
      } else {
        this.setFocus();
      }
    }

    componentDidUpdate(prevProps) {
      if (this.props.currentOption != prevProps.currentOption) {
        if (!this.props.currentOption) {
          this.setState({ initialValue: null, optionSelected: null });
        }
        else {
          this.setState({ optionSelected: this.props.currentOption, initialValue: this.props.currentOption ? this.props.currentOption.name : '' });
        }
      }
      else if (this.props.clearSelected != prevProps.clearSelected && this.state.optionSelected) {
        this.setState({ optionSelected: null, initialValue: '' });
      }
      
      if(!this.state.menu){
        if (this.props.options != this.state.options) {
          this.setState({ options: this.props.options }, () => {
            this.createComboBoxMenu();
          });
        }
      }
      else{
        if (this.props.options != this.state.options) {
          this.setState({ options: this.props.options }, () => {
            const menu = this.createComboBoxMenu();
            this.setState({ menu });
          });
        }
      }
    }

    handleCloseMenu(type, esc) {
      let initialValue = '';
      let currentOption = null;
      if (this.state.menu) {
        if (esc) {
          currentOption = Object.assign({}, this.props.currentOption);
          initialValue = currentOption.name;
          this.handleComboboxMenuSelection(currentOption.type, true);
        }
        this.setState({
          menu: null, initialValue: initialValue, optionSelected: currentOption,
        });
      }
      if (this.props.handleCloseComboBox) {
        this.props.handleCloseComboBox();
      }
      this.setFocus();
    }

    async handleClick(e, something, notMouse) {
      let { options } = this.state;
      if (e && !notMouse) {
        e.stopPropagation();
        e = this.fixupMouse(e);
      }
      if ((!options || !options.length) && this.props.handleFetchOptions) {
        options = await this.props.handleFetchOptions();
        if (options) {
          
        }
        this.setState({ options });
      }

      if (e && e.which == 1) {
        if (!this.state.menu) {
          const menu = this.createComboBoxMenu(this.tempInitialValue);
          if (menu && menu.props.menuOptions.length > 0) {
            this.tempInitialValue = null;
            this.setState({ menu: menu });
          }
        }
        else {
          const rect = this.comboBoxElement.getBoundingClientRect();
          if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom) {
            this.setState({ menu: null });
          }
        }
        this.setFocus();
      }
      else if (!e && notMouse){
        if (!this.state.menu) {
          const menu = this.createComboBoxMenu(this.tempInitialValue);
          if (menu.props.menuOptions.length > 0) {
            this.tempInitialValue = null;
            this.setState({ menu: menu });
          }
        }
        this.setFocus();
      }
    }

    handleMultiMenuSelection(multipleOptions, selectedOption) {
      const { handleMultiMenuSelection } = this.props;
      if (handleMultiMenuSelection) {
        if (selectedOption.all) {
          handleMultiMenuSelection([], selectedOption);
          this.setState({ menu: null });
        }
        else {
          handleMultiMenuSelection(multipleOptions, selectedOption);
        }
      }
    }
  
    createComboBoxMenu(initialValue) {
      const { menuUp, height, multiSelect } = this.props;
      const { currentOption } = this.props;
      const { options, optionSelected } = this.state;
      let maxHeight = this.props.maxHeight ? this.props.maxHeight : null;
      
      if (options && options.length > 0) {
        let initialMenuOption = options.filter(option => option.type == 'create');
        const sortedOptions = options.filter(option => option.type !== 'create');
        if(initialMenuOption && initialMenuOption.length > 0){
          sortedOptions.unshift(...initialMenuOption);
        }

        const menuOptions = sortedOptions.map((option) => {
          if(!option.selected){
            if (optionSelected) {
              if (option.type == optionSelected.type || option.type == optionSelected) {
                option.selected = true;     
              }
              else {
                option.selected = false;
              }
            }
            else if (currentOption) {
              if (option.type == currentOption.type || option.type == currentOption) {
                option.selected = true;
              }
              else {
                option.selected = false;
              }
            }
            else {
              option.selected = false;
            }
          }
          else if(!multiSelect){
            if(currentOption) {
              if (option.type == currentOption.type || option.type == currentOption) {
                option.selected = true;
              }
              else {
                option.selected = false;
              }
            }
            else{
              option.selected = false;
            }
          }
          return (option);
        });

        if (!this.props.dontSortMenu) {
          menuOptions.sort((opt1, opt2) => {
            if (opt1.type === 'create') return -1;
            if (opt2.type === 'create') return 1;
            if (opt1.name && opt2.name && opt1.name.toLowerCase() < opt2.name.toLowerCase()) {
              return -1;
            }
            else if (opt1.name && opt2.name && opt1.name.toLowerCase() > opt2.name.toLowerCase()) {
              return 1;
            }
            else {
              return 0;
            }
          });
        }
        let menu = null;

        if (menuUp) {
          menu = <PopupMenu left={0} bottom={this.props.small ? 24 : 32} width={this.props.width} height={this.props.menuHeight}
            menuOptions={menuOptions} size="small" initialValue={initialValue}
            menuId={this.props.id} popupOnHover={false}
            handleMenuSelection={this.handleComboboxMenuSelection}
            backgroundIndex={this.props.backgroundIndex}
            handleClickAway={this.handleCloseMenu}
            maxHeight={maxHeight}
            multiSelect={multiSelect}
            handleMultiMenuSelection={this.handleMultiMenuSelection}
            showSearchBar={this.props.showSearchBar}
            searchHint={this.props.searchHint}
            handleAddOption={this.props.handleAddOption}
            showTooltip={this.props.showTooltip}
            />;
        }
        else {
          menu = <PopupMenu left={0} top={height ? (height + 2) : 32} width={this.props.width} height={this.props.menuHeight}
            menuOptions={menuOptions} size="small" initialValue={initialValue}
            menuId={this.props.id} popupOnHover={false}
            handleMenuSelection={this.handleComboboxMenuSelection}
            backgroundIndex={this.props.backgroundIndex}
            handleClickAway={this.handleCloseMenu}
            maxHeight={maxHeight}
            multiSelect={multiSelect} 
            handleMultiMenuSelection={this.handleMultiMenuSelection}
            showSearchBar={this.props.showSearchBar}
            searchHint={this.props.searchHint}
            handleAddOption={this.props.handleAddOption}
            handleSearchValue={this.props.handleSearchValue}
            showTooltip={this.props.showTooltip}
            />;
        }
        return menu;
      }
      else {
        return null;
      }
    }

    handleComboboxMenuSelection(type, keyboardSelected) {
      const { handleSelection, clearSelected } = this.props;
      const optionSelectedBase = this.state.options.filter(option => {
        return option.type.toString() == type.toString();
      });
      let optionSelected = null;
      if (optionSelectedBase && optionSelectedBase.length > 0) {
        optionSelected = optionSelectedBase[0];
        if (this.state.optionSelected && (optionSelected.type == this.state.optionSelected.type || optionSelected.type == this.state.optionSelected)) {
          this.setState({ optionSelected: null, initialValue: null });
        }
        else {
          this.setState({ optionSelected: optionSelected, initialValue: optionSelected.name });
        }
      }
      if (!keyboardSelected) {
        this.setState({ menu: null });
        if (handleSelection) {
          handleSelection(type, optionSelected);
          if (clearSelected) {
            this.setState({ optionSelected: null, initialValue: '' });
          }
        }
      }
    }

    handleKeyDown(e) {
      if(this.state.menu){
        return;
      }
      if (e.keyCode == 13 || e.keyCode == 40) {
        this.handleClick(e, false, true);
      }
      else if (e.keyCode == 27) {
        const { handleEscape } = this.props;
        if (handleEscape) {
          handleEscape();
        }
      }
      else if (e.keyCode == 9) {
        e.preventDefault();
      }
      else {
        if (e.key.length == 1) {
          this.setState({ initialValue: e.key });
          this.tempInitialValue = e.key;
          this.handleClick(e, false, true);
        }
      }
    } 

    handleChange(e) {
    }
    
    render() {
      const { width, inputWidth, height, hasBorder, underlined, displayFontStyle, label, tabIndex,
        makeAbsolute, top, left, defaultText, currentOption, disabled, multiSelect, noneAvailabelText, loading } = this.props;
      const { optionSelected, options } = this.state;

      let currentOptionName = defaultText ? defaultText : 'None Selected';
      if (!options || !options.length) {
        currentOptionName = noneAvailabelText ? noneAvailabelText : 'None Available';
      }
      else if (multiSelect) {
       
        const manySelected = options ? options.filter(option => {
          return option.selected;
        }) : [];
        if (manySelected.length > 1) {
          currentOptionName = 'Multiple Selected';
        }
        else if (manySelected.length == 1) {
          currentOptionName = manySelected[0].name;
        }
        else {
          this.props.options.filter(option => {
            if (option.all) {
              currentOptionName = option.name;
              return true;
            }
            return false;
          });
        }
      }
      if (this.state.initialValue) {
        currentOptionName = this.state.initialValue;
      }
      else if (optionSelected && optionSelected.name) {
        currentOptionName = optionSelected.name;
      }
      else if (currentOption) {
        if (currentOption.name) {
          currentOptionName = currentOption.name;
        }
        else {
          const findit = options ? options.filter(option => {
            return option.type ==currentOption;
          }) : [];
          if (findit.length > 0) {
            currentOptionName = findit[0].name;
          }
        }
      }

      let style = { width: inputWidth ? (inputWidth == 'auto' ? 'auto' : inputWidth + 'px') : width + 'px', height: height + 'px' };
      if (makeAbsolute) {
        style.position = 'absolute';
        style.left = left;
        style.top = top;
      }

      // if (overrideStyle) {
      //   style = {...style, ...overrideStyle}
      // }

      const boxClass = 'display-box ' + (hasBorder ? 'bordered' : '') + (underlined ? ' underlined' : '');
      const comboboxMenu = this.state.menu;
      let labelDisplay = null;
      if (label) {
        labelDisplay = <div className="combo-box-label">{label}</div>;
      }

      return (
        <div tabIndex={tabIndex} className="combo-box" style={style} onMouseDown={!disabled ? this.handleClick : null} onKeyDown={!disabled ? this.handleKeyDown : null}
          ref={(element) => { this.comboBoxElement = element; }}>
          {comboboxMenu}
          {labelDisplay}
          <div className={boxClass}>
            <Input className="focus-box" onKeyDown={this.handleKeyDown} ref={(element) => {
              this.comboBox = element;
            }} value={this.state.initialValue || ''} onChange={this.handleChange} readOnly={true}/>
            <div className={'selected-value' + (this.props.adjustHeight ? ' adjust-height' : '') + (this.props.small ? ' small' : '') + (disabled ? ' disabled' : '')} style={displayFontStyle}>{currentOptionName}</div>
            {loading && <div className={'combo-loading' + (this.props.small ? ' small' : '')}><LoadingDots smaller={true} /></div>}
            {this.props.hideCaret || loading ? null : <img className={'caret' + (this.props.small ? ' small' : '')} src={caret} alt="DropDown" />}
          </div>
        </div>
      );
    }
  }



// WEBPACK FOOTER //
// ./src/components/ComboBox/index.js